import { DefaultFilters } from '../classes/FilterHelpers'
import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchUMapTopicPlan (topicId, args) {
  const body = { ...args }
  // Convert filters from object to array
  //if (body.filters) {
    body.filters = DefaultFilters
  //}
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/plan`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_UMAP_TOPIC_PLAN,
    actionReceive: ActionTypes.RECEIVE_UMAP_TOPIC_PLAN,
    actionFailure: ActionTypes.REQUEST_UMAP_TOPIC_PLAN_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId,
      page: args.page
    }
  })
}

function fetchDiscoverGenreDemo ( topicIds) {
  const body = { topic_ids: topicIds }
  return utils.makeApiCall({
    url: '/api/discover/genre-demographics-summary',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_DISCOVER_GENRE_DEMO,
    actionReceive: ActionTypes.RECEIVE_DISCOVER_GENRE_DEMO,
    actionFailure: ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_FAILURE,
    authenticated: true,
    actionProps: {
      topicIds: topicIds
    }
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchUMapTopicPlanIfNeeded (topicId, opts) {
  return (dispatch, getState) => {
    const args = { ...opts }
    args.page = args.page || 1
    const filters = args.filters || null
    const state = (((getState().uMap.byId[topicId] || {}).uMapPlan || {})[filters] || {})[args.page]
    if (utils.shouldFetch(state)) {
      return dispatch(fetchUMapTopicPlan(topicId, args))
    }
    return Promise.resolve()
  }
}

export function fetchDiscoverGenreDemoIfNeeded (topicIds) {
  return (dispatch) => {
    return dispatch(fetchDiscoverGenreDemo(topicIds))
  }
}

export function setUMapSelectedTopic (topicId) {
  return {
    type: ActionTypes.SET_UMAP_SELECTED_TOPIC,
    topicId
  }
}
